import { Box } from '@mui/material';
import { WidgetProps } from '../types';
import Widget, { Header } from './Widget';

export const EmptyWidget = (props: WidgetProps) => {
  return (
    <Widget {...props}>
      <Header title="Widget Unavailable">
        <></>
      </Header>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
        <h2>Widget Unavailable</h2>
      </Box>
    </Widget>
  );
};
